<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Storage Charges</h2>

    <div>
      <button class='btn btn-secondary' (click)='this.exportCsv()' [disabled]='this.visibleLines().length === 0'><i class="fas fa-file-csv"></i> Export CSV</button>&nbsp;
    </div>
  </div>
  <br />

  <div class="form-row">
    <div class="form-group col-md-3">
      <label>Month</label>
      <input type="month" class="form-control" [(ngModel)]='this.month' (change)='this.load()'>
    </div>
    <div class="form-group col-md-4">
      <label>Customer</label>
      <select class='form-control' [(ngModel)]='this.accountId'>
        <option [ngValue]='-1'>All customers</option>
        @for (customer of this.customers(); track customer.id) {
          <option [ngValue]='customer.id'>{{ customer.name }}</option>
        }
      </select>
    </div>
  </div>

  <p class='text-muted'>
    Stock is charged from the day it arrives through the day it leaves, plus {{ this.extraDays }} extra
    day(s) (Company Settings). Dates are the date each movement was entered. Lines marked
    <span class='text-danger'>No rate</span> have no storage rate set and are left out of the totals.
  </p>

  @if (this.isServerError) {
    <div class="alert alert-danger">The charges could not be loaded. Please try again later.</div>
  }

  @if (this.loading) {
    <p>Loading&hellip;</p>
  } @else if (this.visibleLines().length === 0) {
    <div class="alert alert-info">No owned stock was held or received in this month.</div>
  } @else {
    <div class='chargesTable'>
      <table class='table table-sm table-hover'>
        <thead>
          <tr>
            <th>Customer</th><th>Product</th><th>SKU</th><th>Batch</th><th>Unit</th>
            <th class='num'>Days</th><th class='num'>Qty days</th><th class='num'>Storage rate</th><th class='num'>Storage</th>
            <th class='num'>RH&amp;D qty</th><th class='num'>RH&amp;D rate</th><th class='num'>RH&amp;D</th>
          </tr>
        </thead>
        <tbody>
          @for (line of this.visibleLines(); track $index) {
            <tr [class.text-danger]='line.noRate'>
              <td>{{ line.accountName }}</td>
              <td>{{ line.productName }}</td>
              <td>{{ line.sku }}</td>
              <td>{{ line.batchNumber }}</td>
              <td>{{ line.unitName }}</td>
              <td class='num'>{{ line.chargeDays }}</td>
              <td class='num'>{{ line.quantityDays | number:'1.0-4' }}</td>
              <td class='num'>{{ line.storageRate === null ? 'No rate' : (line.storageRate | currency:'GBP':'symbol':'1.2-4') }}</td>
              <td class='num'>{{ line.storageAmount | currency:'GBP' }}</td>
              <td class='num'>{{ line.rhdQty | number:'1.0-4' }}</td>
              <td class='num'>{{ line.rhdRate === null ? (line.rhdQty ? 'No rate' : '') : (line.rhdRate | currency:'GBP':'symbol':'1.2-4') }}</td>
              <td class='num'>{{ line.rhdAmount | currency:'GBP' }}</td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <th colspan='8'>Total (priced lines)</th>
            <th class='num'>{{ this.total('storageAmount') | currency:'GBP' }}</th>
            <th colspan='2'></th>
            <th class='num'>{{ this.total('rhdAmount') | currency:'GBP' }}</th>
          </tr>
          <tr>
            <th colspan='11'>Storage + RH&amp;D</th>
            <th class='num'>{{ this.total('storageAmount') + this.total('rhdAmount') | currency:'GBP' }}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  }
</div>
